/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Decks_No_Deck_YetInputs */



/**
* | output |
* | --- |
* | "No deck uploaded yet" |
*
* @param {Decks_No_Deck_YetInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const decks_no_deck_yet = /** @type {((inputs?: Decks_No_Deck_YetInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Decks_No_Deck_YetInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucun deck téléchargé pour le moment")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se ha cargado ningún deck todavía")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Nenhum deck enviado ainda")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun deck caricato ancora")
	return /** @type {LocalizedString} */ ("No deck uploaded yet")
});